import Api from '@/services/api';

export default {
  messageTemplates() {
    return Api()
      .get('/messagetemplates')
      .then((res) => res.data);
  },
  messageTemplate(id) {
    return Api()
      .get('/messagetemplate/' + id)
      .then((res) => res.data);
  },
  forThread(threadId) {
    return Api()
      .get(`/thread/${threadId}/messagetemplate`)
      .then((res) => res.data);
  },
  create(messageTemplate) {
    return Api()
      .post('/messagetemplate', messageTemplate)
      .then((res) => res.data);
  },
  update(messageTemplate) {
    return Api()
      .put('/messagetemplate/' + messageTemplate.id, messageTemplate)
      .then((res) => res.data);
  },
  delete(messageTemplate) {
    return Api()
      .delete('/messagetemplate/' + messageTemplate.id)
      .then(() => messageTemplate);
  },
};
